import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import AntModal from 'antd/es/modal';

import './Modal.scss';

/**
 * Primary Modal.
 */
const proptypes = {
  type: PropTypes.string,
  wide: PropTypes.bool,
}
const Modal = React.memo( ( { className: customClassName, type, wide, ...p } ) => {

  const className= classnames(
    'Modal', customClassName,
    {
      // ['is-wide']: wide,
      [`is-${type}`]: type,
    }
  );

  return(

    <AntModal
    className={ className }
    { ...p }
    />

);

} );
Modal.Heading = ( { className: customClass, ...p } ) => (
  <h3
  className={ classnames( 'Modal__hding', customClass ) }
  { ...p }
  />
);
Modal.Footer = ( { className, ...p } ) => (
  <div className={ classnames( 'Modal__footer', className ) } { ...p } />
);
Modal.propTypes = proptypes;

export default Modal;